import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { QuoteComponentContext } from './quote-context.interface';

@Component({
    selector: 'app-quote',
    templateUrl: './quote.component.html',
    styleUrls: ['./quote.component.min.css'],
})
export class QuoteComponent implements BuildingBlockInterface {
    @Input() public context: QuoteComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/quote/quote.component.ts